import React, { useState } from 'react'
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@material-ui/core'
import { HiddenIcon, VisibleIcon } from './icons'

/*type PasswordFieldProps = TextFieldProps & {
  component?: React.ElementType
}*/

export function PasswordField(props: TextFieldProps) {
  const [showPassword, setShowPassword] = useState(false)

  /*const Text = props.component ? props.component : TextField*/

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={() => setShowPassword(!showPassword)} tabIndex="-1">
              {showPassword ? <VisibleIcon /> : <HiddenIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  )
}
